











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaResponsavel} from '@/model/resource/CargaResponsavel'
import {CargaResponsavelCollection} from '@/model/collection/CargaResponsavelCollection'
import {ListCargaResponsavelSchema} from '@/schema/resource/CargaResponsavel/ListCargaResponsavelSchema'
import {CsvCargaResponsavelSchema} from '@/schema/resource/CargaResponsavel/CsvCargaResponsavelSchema'

@Component
export default class ListCargaResponsavelView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaResponsavelSchema()
  collection = new CargaResponsavelCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaResponsavel) {
    Helper.pushByName(
      'editCargaResponsavel',
      item.idCargaFk,
      item.idResponsavelFk,
      item.idEnderecoFk,
      item.idFilialFk as number
    )
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaResponsavelCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvCargaResponsavel()
    new CsvCargaResponsavelSchema().downloadCsv(csv.all())
  }
}
